
  import { ref, computed, defineComponent, onMounted } from 'vue';
  import {
    QuestionOptions
  } from '@/_legacy/components/ConductInspection/ConductInspectionItem/ConductInspectionItemQuestion/QuestionOptions';
  import { Button } from '@/ui/components/Button';
  import DropdownModal from '@/_legacy/views/ConductInspection/Modals/DropdownModal.vue';
  import { ENTITY_ITEMS_DROPDOWN_LIMIT } from '@/_legacy/constants';
  import { t } from '@/ui/i18n/i18n';

  interface EntityItem {
    uuid: number;
    title: string;
  }

  interface ConductInspectionItemQuestionEntityItemProps {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    item: {[key: string]: any};
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    entities: {[key: string]: any};
  }

  export default defineComponent<ConductInspectionItemQuestionEntityItemProps>({
    name: 'ConductInspectionItemQuestionEntityItem',
    components: {
      DropdownModal,
      QuestionOptions,
      Button
    },
    props: ['item', 'entities'],
    setup(props, context) {
      const isDropdownVisible = ref(false);
      const normalizedEntityItems = computed(() => {
        return Object.entries(props.entities.inspection.entity_items)
          .map(([uuid, title]): EntityItem => ({
            uuid: Number.parseInt(uuid, 10),
            title: title as string,
          }))
          .sort(
            (a, b) => a.title.localeCompare(b.title)
          );
      });

      const dropdownText = computed(() => {
        const mappedAnswer = props.item.response?.map((entityItemId: number) => {
          return props.entities.inspection.entity_items[entityItemId];
        });

        return props.item.response
          ? mappedAnswer?.join(', ')
          : t('Select from dropdown');
      });

      const entityItemSelected = (entityItemId: number[]) => {
        context.emit('change', {
          uuid: props.item.uuid,
          response: entityItemId.flatMap(f => f || []),
          responded: !!(entityItemId && entityItemId.length),
        });

        closeDropdown();
      };
      const showDropdown = () => {
        isDropdownVisible.value = true;
      };
      const closeDropdown = () => {
        isDropdownVisible.value = false;
      };

      onMounted(() => {
        if (normalizedEntityItems.value.length === 1) {
          entityItemSelected([normalizedEntityItems.value[0].uuid]);
        }
      });

      return {
        isDropdownVisible,
        normalizedEntityItems,
        dropdownText,
        showDropdown,
        closeDropdown,
        entityItemSelected,
        limit: ENTITY_ITEMS_DROPDOWN_LIMIT,
      };
    },
  });
